// extracted by mini-css-extract-plugin
export default {"PasswordChangeForm":"UpdatePassword_PasswordChangeForm__5yLOg","TextInput":"UpdatePassword_TextInput__FiBSj","notification":"UpdatePassword_notification__TEWwa"};